import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/internal/Subject';

import { StorageService } from './storage.service';
import { Observable } from 'rxjs';
import { UserToken } from '../model/user-token';
import { BaseStorageService } from './base-storage.service';
import { DateService } from './date.service';

@Injectable({
  providedIn: 'root',
})
export class SecurityTokenStorage<T> extends BaseStorageService<T> {
  private OnSessionExpired = new Subject<UserToken>();

  constructor(storageService: StorageService) {
    super(storageService);
  }

  private static loginExpired(userToken: UserToken) {
    return DateService.datetimeIsBefore(
      DateService.getDate(userToken.tokenExpirationDate),
      DateService.currentDate()
    );
  }

  public onSessionExpired(): Observable<any> {
    return this.OnSessionExpired;
  }

  protected getStorageKey(): string {
    return 'eyesCloud3D';
  }

  public getAcceptedLogin(): T {
    return super.getObjectValue();
  }
}
